export enum Network {
  MAINNET = "Mainnet",
  LISBON = "Lisbon",
}
